import React, { Component } from "react";
import { WebFormFieldProps } from "./index";
import { DefaultProps } from "@eres/forms";
import { readError } from "@eres/forms/Utils";

export default class FormField<T, XT> extends Component<WebFormFieldProps<T, XT>> {
	static defaultProps: DefaultProps<WebFormFieldProps<any, any>> = {
		containerClassName: "form-group mb-4",
		errorClassName: "invalid-feedback invalid-feedback-x",
		hideLabel: false
	};

	render() {
		const {
			label, required, id, containerClassName, error,
			errorClassName, labelClassName, hideLabel
		} = this.props;
		let xError = error;
		if ( error == null )
			xError = readError( this.props );
		return (
			<React.Fragment>
				<div className={ containerClassName }>
					{ !hideLabel &&
						<label className={ labelClassName } htmlFor={ id }><span>{ label }</span>
                        {required && <span className="asterisk"> *</span> }
						</label>
					}
					{ this.props.children }
					{ xError && <div className={ errorClassName }>
						{ xError }
					</div> }
				</div>

			</React.Fragment>
		);
	}
}
